import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useFeature } from '../hooks/useFeature';

// Pages for a feature the club has switched off send people home
export default function FeatureRoute({ feature, to = '/dashboard' }) {
  return useFeature(feature) ? <Outlet /> : <Navigate to={to} replace />;
}
